import * as React from 'react';
import { Button, useDeviceType } from '@cian/ui-kit';
import { IButtonProps } from '@cian/ui-kit/button/types';
import { useDispatch } from 'react-redux';

import { setActiveStep } from '../../actions';
import { EActiveConsultationModal } from '../../types/redux/consultationRequest';

interface IConsultationRequestButtonContainerProps extends IButtonProps {
  onGetConsultationClick?: () => void;
}

/**
 * Кнопка для открытия модалки "Хочу консультацию"
 */
export const ConsultationRequestButtonContainer: React.FC<IConsultationRequestButtonContainerProps> = ({
  children,
  theme,
  size = 'L',
  fullWidth,
  onGetConsultationClick,
}) => {
  const deviceType = useDeviceType();
  const dispatch = useDispatch();

  const handlerClick = () => {
    dispatch(setActiveStep(EActiveConsultationModal.ChoosingConsultationType));
    onGetConsultationClick?.();
  };

  return (
    <Button
      size={size}
      theme={theme}
      fullWidth={fullWidth || deviceType !== 'desktop'}
      data-testid="ConsultationRequestButtonContainer"
      onClick={handlerClick}
    >
      {children}
    </Button>
  );
};
